import { Link } from "@tanstack/react-router";
import type { CourseKey, SubscriptionCourseProduct } from "@/api/api.types";
import type { Kurs } from "@/kursy/general";
import { CourseTitleCard } from "./CourseTitleCard";

interface CourseProductPickerProps {
	courseKey: CourseKey;
	parentKurs: Kurs | undefined;
	products: Array<SubscriptionCourseProduct>;
}

export const CourseProductPicker = ({
	courseKey,
	parentKurs,
	products,
}: CourseProductPickerProps): JSX.Element => {
	return (
		<main className="py-3 px-safe-offset-3 min-h-[calc(100vh-176px)] overflow-x-hidden max-w-[890px] mx-auto">
			<div className="flex flex-col gap-3">
				{products.map((product) => {
					const tileSlug = product.slug ?? String(product.id);
					const synthetic: Kurs = parentKurs
						? {
								...parentKurs,
								slug: tileSlug,
								title: product.name,
								productId: product.id,
								// Strip parent's `level` so CourseTitleCard surfaces the
								// per-category badge — distinguishes tiles that share a
								// `generalny`-level parent (e.g. doradca-podatkowy bundles).
								level: null,
							}
						: {
								slug: tileSlug,
								title: product.name,
								description: "",
								category: null,
								level: null,
								productId: product.id,
							};
					return (
						<Link
							key={product.id}
							to="/course/$courseKey/$productId"
							params={{ courseKey, productId: String(product.id) }}
							className="w-full text-left"
						>
							<CourseTitleCard kurs={synthetic} />
						</Link>
					);
				})}
			</div>
		</main>
	);
};
